export default {
    SET_EXISTING_EMAIL: 'SET_EXISTING_EMAIL',
    FSDO_SET_REQUEST_ERROR_MSG: 'FSDO_SET_REQUEST_ERROR_MSG',
    FSDO_TOGGLE_ERROR_MSG: 'FSDO_TOGGLE_ERROR_MSG'
}
